import gql from 'graphql-tag';

export const registerCustomCodeMutation = gql`
  mutation registerCustomCode($customCode: String!) {
    registerCustomCode(customCode: $customCode) {
      resultCode
      homeTesting {
        id
        patientId
        customCode
        status
      }
    }
  }
`;
